// websocekt client

let sock: WebSocket | undefined

export enum WebSocketState {
  CONNECTING = 0,
  OPEN,
  CLOSING,
  CLOSED,
  NOT_INIT,
}

function disposeSocket(prev: WebSocket | undefined) {
  if (!prev) return
  try {
    prev.onopen = null
    prev.onclose = null
    prev.onerror = null
    prev.onmessage = null
    if (prev.readyState === WebSocketState.CONNECTING || prev.readyState === WebSocketState.OPEN) {
      prev.close(1000, "replaced")
    }
  } catch {
    //
  }
}

export class WebScoketClient {
  onOpen: () => void
  onClose: (event: WebSocketCloseEvent) => void
  onData: (blob: Uint8Array) => void
  onError: (e: WebSocketErrorEvent) => void

  constructor({ onOpen, onData, onError, onClose }) {
    this.onOpen = onOpen
    this.onClose = onClose
    this.onData = onData
    this.onError = onError
  }

  connect(url: string) {
    disposeSocket(sock)
    sock = new WebSocket(url)
    sock.binaryType = "arraybuffer"
    sock.onopen = this.onOpen
    sock.onclose = this.onClose
    sock.onerror = this.onError
    sock.onmessage = (event: WebSocketMessageEvent) => {
      const blob = new Uint8Array(event.data)
      this.onData(blob)
    }
  }

  send(b: Uint8Array) {
    if (this.ready && sock) {
      return sock.send(b)
    }
  }

  close() {
    disposeSocket(sock)
    sock = undefined
  }

  get ready() {
    return !!sock && sock.readyState === WebSocketState.OPEN
  }

  get state() {
    return sock ? sock.readyState : WebSocketState.NOT_INIT
  }
}
